<template>
  <cost-prices-rule-detail
    ref="costPricesRuleDetail"
    type="edit"
    :submitting="submitting"
    :values="data"
    @submit="submit"
  />
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import CostPricesRuleDetail from './CostPricesRuleDetail.vue';

export default {
  components: {
    CostPricesRuleDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      data: {}
    };
  },

  created() {
    const { providerId, ruleId } = this.$route.params;
    this.getRuleData(providerId, ruleId);
  },
  methods: {
    submit(data) {
      const formData = {
        providerId: this.$route.params.providerId,
        ...data,
        ruleId: this.$route.params.ruleId
      };

      this.submitting = true;
      useService.pricingService
        .updateProviderRule(formData)
        .then(response => {
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({
            name: 'cost-prices-rules'
          });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getRuleData(providerId, ruleId) {
      this.submitting = true;
      useService.pricingService
        .getProviderRuleDetail(providerId, ruleId)
        .then(response => {
          const { type, value, operator, price, pricingType, provider, countries, minimumPrice } =
            response.data;

          this.data = {
            ruleType: type,
            ruleOperator: operator,
            ruleValue: value,
            priceType: pricingType,
            priceValue: price,
            providerId: provider?.id || provider,
            countries: Array.isArray(countries)
              ? countries.map(c => (typeof c === 'object' && c ? c.id : c))
              : [],
            minimumPrice: minimumPrice != null ? minimumPrice : null
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
